export default __webpack_public_path__ + "static/media/Olam.9883060d.svg";